export const pendingServiceData = [
            {
                id: "1",
                services: "Computer Repair",
                category: "Computer",
                subCategory: "Other",
                price: "$80",
                duration: "10:00",
                status: "Pending",
                createdby: "Provider",
                action: "Edit\n Delete"
            },
            {
                id: "2",
                services: "Car Repair Services",
                category: "Automobile",
                subCategory: "Other",
                price: "$50",
                duration: "12:00",
                status: "Pending",
                createdby: "Admin",
                action: "Edit\n Delete"
            },
            {
                id: "3",
                services: "Steam Car Wash",
                category: "Car Wash",
                subCategory: "Other",
                price: "$14",
                duration: "14:00",
                status: "Pending",
                createdby: "Provider",
                action: "Edit\n Delete"
            },
            {
                id: "4",
                services: "House Cleaning",
                category: "Cleaning",
                subCategory: "Other",
                price: "$100",
                duration: "16:00",
                status: "Pending",
                createdby: "Admin",
                action: "Edit\n Delete"
            }
        ]
   